import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import { responseInterceptor, errorInterceptor } from './interceptors';
import { Environment } from '../../../../environment';

const Apiestoque = axios.create({
  baseURL: Environment.URL_BASEESTOQUE,
});
const Apiesolicitacao = axios.create({
  baseURL: Environment.URL_BASESOLICITACAO,
});
const attachTokenInterceptor = (apiInstance: AxiosInstance) => {
  apiInstance.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
      const token = localStorage.getItem('APP_ACCESS_TOKEN');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      } else {
        delete config.headers.Authorization;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
  apiInstance.interceptors.response.use(
    (response) => responseInterceptor(response),
    (error) => errorInterceptor(error)
  );
};
attachTokenInterceptor(Apiestoque);
attachTokenInterceptor(Apiesolicitacao);

export { Apiestoque, Apiesolicitacao };
